import { PageHeader } from "@/components/ui/page-header";

const PatientSurvey = () => {
  return (
    <div>
      <PageHeader
        title="Patient Survey"
        description="Help us improve our services."
      />
      <div className="container mx-auto px-4 py-16">
        <h2 className="mb-4 text-3xl font-bold">Patient Survey</h2>
        <p>Content coming soon...</p>
      </div>
    </div>
  );
};

export default PatientSurvey; 